<p-toast key="top-right" [baseZIndex]="99999"></p-toast>
<p-confirmDialog></p-confirmDialog>
<div class="layout-topbar shadow-4">
    <div class="layout-topbar-left">
        <a class="layout-topbar-logo" routerLink="/pages/home/inicio">
            <!-- <img id="app-logo" src="assets/logo_color.png" alt="pago-facil" style="height: 3.5rem"> -->

            <!-- <img  [src]="urlImage + '/' + user?.imagen"  alt="Image" style="height: 100%; width: 100%; object-fit: cover;"> -->
            <!-- <img id="app-logo" src="assets/images/FINEXUS_imagotipo_blanco.svg" alt="pago-facil" style="height: 6.5rem"> -->
            <ng-container *ngIf="user && user.imagen; else noImage">
                    <img [src]="urlImage + '/' + user.imagen" alt="Image" style="width: 100%; height: 100%; object-fit: contain;">
            </ng-container> 
            <ng-template #noImage>
                <div style="width: 20rem; height: 3.5rem; overflow: hidden; display: flex; align-items: center; justify-content: center;">
                    <h2 style="font-family: 'Audiowide'; font-size: 1.5rem; margin-top: 0.5rem; margin-left: 2rem; word-wrap: break-word;">{{ user?.nombre }}</h2>
                </div>
            </ng-template>   
            <!-- <img id="app-logo" src="assets/layout/images/logo-light.svg" alt="ultima-layout" style="height: 2.25rem"> -->
        </a>

        <a class="layout-menu-button shadow-6" (click)="appMain.onMenuButtonClick($event)" pRipple>
            <i class="pi pi-chevron-right"></i>
        </a>

        <a class="layout-topbar-mobile-button" (click)="appMain.onTopbarMobileButtonClick($event)" pRipple>
            <i class="pi pi-ellipsis-v fs-large"></i>
        </a>
    </div>

    <div class="layout-topbar-right" [ngClass]="{'layout-topbar-mobile-active': appMain.mobileTopbarActive}">
        <div class="layout-topbar-actions-left">
            <p-megaMenu [model]="model" styleClass="layout-megamenu"></p-megaMenu>
        </div>
        <div class="layout-topbar-actions-right">
            <ul class="layout-topbar-items">
                <!-- BUSCADOR -->
                <!-- <li class="layout-topbar-item layout-search-item">
                    <a class="layout-topbar-action rounded-circle" (click)="appMain.onTopbarItemClick($event, 'search')" pRipple>
                        <i class="pi pi-search fs-large"></i>
                    </a>
                    <div class="layout-search-panel p-inputgroup" [@topbarActionPanelAnimation]="'visible'" *ngIf="appMain.search" (@topbarActionPanelAnimation.done)="onSearchAnimationEnd($event)">
                        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                        <input #searchInput type="text" pInputText placeholder="Search" (click)="appMain.searchClick = true;" (keydown)="appMain.onSearchKeydown($event)">
                        <span class="p-inputgroup-addon">
                            <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-text p-button-plain" (click)="appMain.searchClick = false;"></button>
                        </span>
                    </div>
                </li> -->
                <!-- NOTIFICACIONES -->
                <!-- <li class="layout-topbar-item notifications">
                    <a class="layout-topbar-action rounded-circle" (click)="appMain.onTopbarItemClick($event, 'notifications')" pRipple>
                        <span class="p-overlay-badge">
                            <i class="pi pi-bell fs-large"></i>
                            <span class="p-badge p-badge-warning p-badge-dot"></span>
                        </span>
                    </a>

                    <ul class="layout-topbar-action-panel shadow-6" [@topbarActionPanelAnimation]="'visible'" *ngIf="appMain.activeTopbarItem === 'notifications'">
                        <li class="mb-3">
                            <span class="px-3 fs-small">You have <b>4</b> new notifications</span>
                        </li>
                        <li class="layout-topbar-action-item">
                            <div class="flex flex-row align-items-center">
                                <img src="assets/demo/images/avatar/avatar-1.png"/>
                                <div class="flex flex-column" [ngClass]="{'ml-3': !app.isRTL, 'mr-3': app.isRTL}" style="flex-grow: 1;">
                                    <div class="flex align-items-center justify-content-between mb-1">
                                        <span class="fs-small font-bold">Jerome Bell</span>
                                        <small>42 mins ago</small>
                                    </div>
                                    <span class="fs-small">How to write content about your photographs?</span>
                                </div>
                            </div>
                        </li>
                        <li class="layout-topbar-action-item">
                            <div class="flex flex-row align-items-center">
                                <img src="assets/demo/images/avatar/avatar-2.png"/>
                                <div class="flex flex-column" [ngClass]="{'ml-3': !app.isRTL, 'mr-3': app.isRTL}" style="flex-grow: 1;">
                                    <div class="flex align-items-center justify-content-between mb-1">
                                        <span class="fs-small font-bold">Cameron Williamson</span>
                                        <small>48 mins ago</small>
                                    </div>
                                    <span class="fs-small">Start a blog to reach your creative peak.</span>
                                </div>
                            </div>
                        </li>
                        <li class="layout-topbar-action-item">
                            <div class="flex flex-row align-items-center">
                                <img src="assets/demo/images/avatar/avatar-3.png"/>
                                <div class="flex flex-column" [ngClass]="{'ml-3': !app.isRTL, 'mr-3': app.isRTL}" style="flex-grow: 1;">
                                    <div class="flex align-items-center justify-content-between mb-1">
                                        <span class="fs-small font-bold">Anna Miles</span>
                                        <small>1 day ago</small>
                                    </div>
                                    <span class="fs-small">Caring is the new marketing</span>
                                </div>
                            </div>
                        </li>
                        <li class="layout-topbar-action-item">
                            <div class="flex flex-row align-items-center">
                                <img src="assets/demo/images/avatar/avatar-4.png"/>
                                <div class="flex flex-column" [ngClass]="{'ml-3': !app.isRTL, 'mr-3': app.isRTL}" style="flex-grow: 1;">
                                    <div class="flex align-items-center justify-content-between mb-1">
                                        <span class="fs-small font-bold">Arlene Mccoy</span>
                                        <small>4 day ago</small>
                                    </div>
                                    <span class="fs-small">Starting your traveling blog with Vasco.</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li> -->
                <!-- ACCESOS DIRECTOS -->
                <!-- <li class="layout-topbar-item app">
                    <a class="layout-topbar-action rounded-circle" (click)="appMain.onTopbarItemClick($event, 'apps')" pRipple>
                        <i class="pi pi-table fs-large"></i>
                    </a>

                    <div class="layout-topbar-action-panel shadow-6" [@topbarActionPanelAnimation]="'visible'" *ngIf="appMain.activeTopbarItem === 'apps'">
                        <div class="grid grid-nogutter">
                            <div class="layout-topbar-action-item col-4">
                                <a class="flex align-items-center flex-column text-color" pRipple>
                                    <i class="pi pi-image action indigo-bgcolor white-color"></i>
                                    <span>Products</span>
                                </a>
                            </div>
                            <div class="layout-topbar-action-item col-4">
                                <a class="flex align-items-center flex-column text-color" pRipple>
                                    <i class="pi pi-file-pdf action orange-bgcolor white-color"></i>
                                    <span>Reports</span>
                                </a>
                            </div>
                            <div class="layout-topbar-action-item col-4">
                                <a class="flex align-items-center flex-column text-color" pRipple>
                                    <i class="pi pi-dollar action teal-bgcolor white-color"></i>
                                    <span>Balance</span>
                                </a>
                            </div>
                            <div class="layout-topbar-action-item col-4">
                                <a class="flex align-items-center flex-column text-color" pRipple>
                                    <i class="pi pi-cog action pink-bgcolor white-color"></i>
                                    <span>Settings</span>
                                </a>
                            </div>
                            <div class="layout-topbar-action-item col-4">
                                <a class="flex align-items-center flex-column text-color" pRipple>
                                    <i class="pi pi-key action bluegrey-bgcolor white-color"></i>
                                    <span>Credentials</span>
                                </a>
                            </div>
                            <div class="layout-topbar-action-item col-4">
                                <a class="flex align-items-center justify-content-center flex-column text-color" pRipple>
                                    <i class="pi pi-sitemap action cyan-bgcolor white-color"></i>
                                    <span>Sitemap</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </li> -->
                <li class="layout-topbar-item">
                    <a class="layout-topbar-action flex flex-row justify-content-center align-items-center px-2" (click)="appMain.onTopbarItemClick($event, 'profile')" pRipple>
                        <div>{{ currentUser.nombre }}</div>
                        <p-avatar [label]="iniciales" shape="circle" size="large" styleClass="ml-2"></p-avatar>
                        <!-- <img src="assets/demo/images/avatar/amyelsner.png" alt="avatar" style="width: 32px; height: 32px;"> -->
                    </a>

                    <ul class="layout-topbar-action-panel shadow-6" [@topbarActionPanelAnimation]="'visible'" *ngIf="appMain.activeTopbarItem === 'profile'">
                        <!-- <li class="layout-topbar-action-item">
                            <a class="flex flex-row align-items-center" pRipple>
                                <i class="pi pi-cog" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                                <span>Settings</span>
                            </a>
                        </li>
                        <li class="layout-topbar-action-item">
                            <a class="flex flex-row align-items-center" pRipple>
                                <i class="pi pi-file-o" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                                <span>Terms of Usage</span>
                            </a>
                        </li> -->
                        <li class="layout-topbar-action-item">
                            <a class="flex flex-row align-items-center" pRipple (click)="cambiarContrasenha()">
                                <i class="pi pi-key" style="color: blue;" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                                <span>Cambiar Contraseña</span>
                            </a>
                        </li>
                        <li class="layout-topbar-action-item">
                            <a class="flex flex-row align-items-center" pRipple (click)="salir()">
                                <i class="pi pi-power-off" style="color: red;" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                                <span>Salir</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <!-- <li class="layout-topbar-item">
                    <a class="layout-topbar-action rounded-circle" (click)="appMain.onRightMenuButtonClick($event)" pRipple>
                        <i class="pi fs-large" [ngClass]="{'pi-arrow-left': !app.isRTL, 'pi-arrow-right': app.isRTL}"></i>
                    </a>
                </li> -->
            </ul>
        </div>
    </div>
</div>

<p-dialog [(visible)]="showDialogPassword" position="center" modal="true" header="Cambiar Contraseña" [breakpoints]="{'960px': '75vw', '400px': '95vw'}" [style]="{width: '50vw'}" [closeOnEscape]="false" [closable]="false" >
    <div class="grid">
        <div class="col-12">
            <p><b>Recomendaciones</b></p>
            <p>1. Por su seguridad trate que la contraseña tenga alguna letra mayúscula, minúscula, numero y/o algun caracter especial.</p>
            <p>2. Evite fechas de naciminento, su propio nombre o codigo de usuario.</p>
            <p>3. Evite numeros consecutivos. Ej: 123456.</p>
            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="confirmarPass()" >
                <div class="p-fluid p-formgrid grid flex align-items-center flex-wrap">
                    <div class="field col-12 md:col-4">
                        <label htmlFor="oldPassword">Contraseña Anterior</label>
                        <span class="p-input-icon-right">
                            <input pInputText [type]="passType" id="oldPassword" type="text" formControlName="oldPassword" />
                            <i *ngIf="passType==='password'" style="font-size: 1.2rem;" class="pi pi-lock" (click)="showPassword('text')"></i>
                            <i *ngIf="passType==='text'" style="font-size: 1.2rem;" class="pi pi-lock-open" (click)="showPassword('password')"></i>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="password1">Nueva Contraseña</label>
                        <span class="p-input-icon-right">
                            <input pInputText [type]="passType" id="password1" type="text" formControlName="password1" />
                            <i *ngIf="passType==='password'" style="font-size: 1.2rem;" class="pi pi-lock" (click)="showPassword('text')"></i>
                            <i *ngIf="passType==='text'" style="font-size: 1.2rem;" class="pi pi-lock-open" (click)="showPassword('password')"></i>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="password2">Repetir Contraseña</label>
                        <span class="p-input-icon-right">
                            <input pInputText [type]="passType" id="password2" type="text" formControlName="password2" />
                            <i *ngIf="passType==='password'" style="font-size: 1.2rem;" class="pi pi-lock" (click)="showPassword('text')"></i>
                            <i *ngIf="passType==='text'" style="font-size: 1.2rem;" class="pi pi-lock-open" (click)="showPassword('password')"></i>
                        </span>
                    </div>
                </div>
                <div class="p-fluid p-formgrid grid flex align-items-center flex-wrap">
                    <div class="field col-12 md:col-4">
                        <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-warning" label="Cancelar" (click)="cancelarPass()"></button>
                    </div>
                    <div class="field col-12 md:col-4">
                        <button pButton pRipple type="submit" icon="pi pi-check" class="p-button-rounded" label="Confirmar"></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</p-dialog>
